import { maybe } from '@passionware/monads';
import React from 'react';
import { BookingCostDialog } from 'v5/features/productions/booking-costs/BookingCostDialog';
import { EntitySpec } from 'v5/features/productions/booking-costs/types';
import { WithServices } from 'v5/platform/ts/services';
import { WithResourceService } from 'v5/services/io/ResourceService/ResourceService';
import { withRootServices } from 'v5/services/services.connected.app';
import { WithAppScopeService } from 'v5/services/internal/AppScopeService/AppScopeService';
import { WithSystemSettingsService } from 'v5/services/internal/SystemSettingsService/SystemSettingsService';
import { ResourceSlot } from '../../../../../../__types__';

export interface BookingCostsFlyoverProps
  extends WithServices<
    [WithAppScopeService, WithSystemSettingsService, WithResourceService]
  > {
  className?: string;
  expenseId: number;
  bookingId: number;
  slot: ResourceSlot; // Replace 'any' with the actual type if known
  children: React.ReactNode;
}

const BookingCostsFlyover = ({
  className,
  expenseId,
  bookingId,
  slot,
  children,
  services
}: BookingCostsFlyoverProps) => {
  const productionId = maybe.getOrThrow(
    slot.production_id,
    'productionId is required'
  );

  const entitySpec: EntitySpec =
    'expenses' in slot
      ? {
          type: 'expense',
          productionId,
          expenseId: expenseId,
          slotId: slot.id
        }
      : {
          type: 'booking',
          productionId,
          bookingId: bookingId,
          slotId: slot.id
        };

  return (
    <BookingCostDialog
      entitySpec={entitySpec}
      className={className}
      services={services}
    >
      {children}
    </BookingCostDialog>
  );
};

export default withRootServices(BookingCostsFlyover);
